import {
  call,
  ForkEffect,
  putResolve,
  select,
  takeLeading,
} from "redux-saga/effects";
import {
  getRepeatAlertFailure,
  getRepeatAlertSuccess,
} from "../../redux/repeatAlert/actions";
import {
  IGetRepeatSettingsRequest,
  REPEAT_ALERT,
} from "../../redux/repeatAlert/types";
import { AxiosCustom } from "../../service/Axios";

import { IAppState } from "../../redux/types";

export function* getRepeatAlertsWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    REPEAT_ALERT.GET_NODE_SETTINGS_REQUEST,
    getRepeatAlertsSaga
  );
}
function* getRepeatAlertsSaga(action: IGetRepeatSettingsRequest) {
  try {
    const state: IAppState = yield select();
    const orgId = state?.organization.organizationId;
    if (orgId) {
      const response = yield call(() =>
        AxiosCustom.getRepeatAlertSettings(orgId)
      );
      const result = { ...response.data };
      yield putResolve(getRepeatAlertSuccess(result));
    }
  } catch (error) {
    yield putResolve(getRepeatAlertFailure());
  }
}
